import ImageCarousel from '../components/content/imagecarousel/image-carousel'
import FeaturedImageCarousel from '../components/content/featuredimagecarousel/featured-image-carousel'
import FullImageCarousel from '../components/content/fullimagecarousel/full-image-carousel'
import Carousel from '../components/content/carousel/carousel'
import Accordion from '../components/content/accordion/accordion'
import Drawer from '../components/content/drawer/drawer'
import { Header } from '../components/header/header'
import Gallery from '../components/content/gallery/gallery'
import HeroBanner from '../components/content/herobanner/hero-banner'
import FormValidation from '../components/atoms/forms/form-validation'
import NewsletterSignup from '../components/atoms/forms/newsletter-signup'
import ModalPopup from '../components/content/modalpopup/modal-popup'
import ModalGallery from '../components/content/modalgallery/modal-gallery'
import LocationDetail from '../components/content/locationdetail/location-detail';
import LocationInformation from '../components/content/locationinformation/location-information';
import SpecialsList from '../components/content/specials/specials-list';
import RegionSpecialsList from '../components/content/specials/region-specials-list';
import HeroCarouselCard from '../components/content/herocarouselcard/hero-carousel-card';
import HeroCarousel from '../components/content/herocarousel/hero-carousel';
import ModelSearch from '../components/content/modelsearch/model-search';
import VehicleDetail from '../components/content/vehicledetail/vehicle-detail'
import { googleAnalytics } from './datalayer'
import CampaignCta from '../components/campaign/cta/cta'

import { initCvSolutions } from "./custom/cv-solutions";
import { initGliderSwipe } from "./custom/glider-swipe";

import { initCarousel } from "./common/carousel";

const componentScripts = {
  ImageCarousel,
  Gallery,
  Accordion,
  Drawer,
  FeaturedImageCarousel,
  FullImageCarousel,
  HeroBanner,
  FormValidation,
  NewsletterSignup,
  Header,
  ModalPopup,
  ModalGallery,
  LocationDetail,
  LocationInformation,
  SpecialsList,
  RegionSpecialsList,
  HeroCarouselCard,
  HeroCarousel,
  Carousel,
  ModelSearch,
  VehicleDetail,
  CampaignCta
};

window.GoogleAnalytics = googleAnalytics();

let componentName, componentScript;

const componentElements = document.querySelectorAll('[data-component]');
// iterate over all component elements
for (const el of componentElements) {
  componentName = el.getAttribute('data-component');
  // get the script that matches the component
  componentScript = componentScripts[componentName];
  // if the script exists
  if (typeof componentScript !== 'undefined') {
    // and init method exists, initialize the script
    if (componentScript.init) {
      componentScript.init(el);
      // if not but script is a class/fn-type, instantiate the class/fn
    } else if (typeof componentScript === 'function') {
      new componentScript(el);
    }
  }
}

initCvSolutions();
initCarousel();
initGliderSwipe();